
import  axios  from 'axios';
//import FileReader from 'FileReader';
//import ReactFileReader from 'react-file-reader';

var FileSaver = require('file-saver');
//var FileReader = require('filereader.js');


export const LOAD_PDF_FILE = 'pdf/LOAD_PDF_FILE';



export function loadPdfFileInStore(argFaxDataArray) {
    return {
        type: LOAD_PDF_FILE,
        pdfFile:argFaxDataArray
    }
}


/********************* End of InStore calls **************************/

//****************************************
//Below is for update a Stream
//****************************************







//Get list of companys

export function loadPdfFile(argURL, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        getListOfPdfs(argURL, argCompanyId, state.login.loginData.idToken, state.user.saveUserResp.id).then(function(pdfdata){

            dispatch(loadPdfFileInStore(pdfdata));

    }, function(err){
        console.log("I had an error gettting Farms Data2" + err);
        });
    }//end of return
}

function getArrayOfGetsForListOfPdfs(argURL,argCompanyId ,argIdToken, argUserId  ){
    /*
     I build something like this :
     http://localhost:4567/company
     */

    let baseUrl = argURL+"files/";
    console.log(" on getting list of pdf  the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.get(baseUrl,{headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}

function getListOfPdfs( argURL, argCompanyId ,argIdToken, argUserId ){

    var returnPromise = new Promise(function(resolve, reject){



        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfGetsForListOfPdfs(argURL, argCompanyId ,argIdToken, argUserId )).then(function(responses){
                var len = responses[0].data.length;
                console.log("The pdf file length is " + len);
                var bytes2 = new Uint8Array(len);
                for (var j = 0; j < len; j++){
                    bytes2[j] = responses[0].data.charCodeAt(j);
                }
                var file = new Blob(bytes2, {type: "application/pdf"});
                //"application/octet-stream"
                //"application/pdf"
                //FileSaver.saveAs(file, "myacgtionfile.pdf");

                //var fileReader = new ReactFileReader();
                //var byteArray = ReactFileReader.//readAsArrayBuffer(responses[0].data);
                //FileSaver.saveAs(byteArray, "mybyterarray.pdf");

                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on getting list of Storage " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}

